import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GlobalErrorType } from '~/enums';
import {
  ApiErrorDiagnostics,
  CustomGlobalError,
  GlobalErrorState,
} from '~/Interfaces';

const globalErrorInitialState: GlobalErrorState = Object.freeze({
  hasError: false,
  errorType: GlobalErrorType.API_FAILURE,
  showBanner: false,
  showCardOfferBanner: false,
});

const globalErrorSlice = createSlice({
  name: 'globalError',
  initialState: globalErrorInitialState,
  reducers: {
    toggleGlobalErrorOn: (state, action: PayloadAction<GlobalErrorType>) => {
      state.hasError = true;
      state.errorType = action.payload;
    },
    toggleGlobalErrorOff: (state) => {
      state.hasError = false;
      state.apiErrorDiagnostics = undefined;
    },
    hideBanner: (state) => {
      state.showBanner = false;
    },
    hideCardOfferBanner: (state) => {
      state.showCardOfferBanner = false;
    },
    setCustomGlobalError: (state, action: PayloadAction<CustomGlobalError>) => {
      state.customGlobalError = action.payload;
    },
    setApiErrorDiagnostics: {
      reducer: (state, action: PayloadAction<ApiErrorDiagnostics>) => {
        state.apiErrorDiagnostics = action.payload;
      },
      // prepare keeps the impure Date.now() call out of the reducer body.
      prepare: (diagnostics: Omit<ApiErrorDiagnostics, 'capturedAt'>) => ({
        payload: { ...diagnostics, capturedAt: Date.now() },
      }),
    },
  },
});

export const {
  toggleGlobalErrorOn,
  toggleGlobalErrorOff,
  setCustomGlobalError,
  setApiErrorDiagnostics,
} = globalErrorSlice.actions;

export default globalErrorSlice.reducer;
